// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"83d62310","75":"9758426e","126":"cba8fe34","489":"fc351b61","522":"1412dc7f","601":"fc351b61","706":"fc351b61"}[chunkId] + ".chunk.css";
};